import httpClient from "Api/httpClient";

const END_POINT = "/fe_invoices";

const getFeInvoices = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getFeInvoice = (invoice_id) => {
    if (!invoice_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + invoice_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printFeInvoice = (invoice_id, view_as = null) => {
    if (!invoice_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?invoice_id=" + invoice_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createFeInvoices = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateFeInvoices = (payload, invoice_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + invoice_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteFeInvoices = (invoice_id) => {
    const DELETE_END_POINT = END_POINT + "/" + invoice_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getFeInvoices, getFeInvoice, printFeInvoice, createFeInvoices, updateFeInvoices, deleteFeInvoices };
